export const isIndiaCountry = (country) => {
  const c = String(country || '').trim().toLowerCase();
  return c === 'india' || c.includes('india');
};

export const normalizePincode = (value) => String(value || '').replace(/\s+/g, '').trim();

export const isValidIndianPincode = (value) => {
  const p = normalizePincode(value);
  return /^[1-9][0-9]{5}$/.test(p);
};

export const fetchIndiaPincodeDetails = async ({ apiBase = '', pincode }) => {
  const pin = normalizePincode(pincode);
  const res = await fetch(`${apiBase}/api/geo/pincode/${encodeURIComponent(pin)}`);
  const json = await res.json().catch(() => ({}));

  if (!res.ok || !json?.success) {
    const message = json?.message || 'Failed to lookup pincode';
    const error = new Error(message);
    error.status = res.status;
    error.payload = json;
    throw error;
  }

  return json.data;
};

export const fetchIndiaServiceability = async ({ apiBase = '', pincode }) => {
  const pin = normalizePincode(pincode);
  const res = await fetch(`${apiBase}/api/geo/serviceability/${encodeURIComponent(pin)}`);
  const json = await res.json().catch(() => ({}));

  if (!res.ok || !json?.success) {
    const message = json?.message || 'Failed to check serviceability';
    const error = new Error(message);
    error.status = res.status;
    error.payload = json;
    throw error;
  }

  return json.data;
};
